import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/websiteAudit.actions'
import { processAuditIssues } from './webAuditHelpers/auditIssues'
import { getSorted } from './webAuditHelpers/getSorted'

const initialState = {
  audits: null,
  audit: [],
  fixesList: null,
  auditCrawlData: null,
  auditCrawlDataIssues: {
    content_readability_ari: 0,
    content_readability_coleman_liau: 0,
    content_readability_dale_chall: 0,
    content_readability_flesh_kincaid: 0,
    crawl_depth: 0,
    description: 0,
    description_consistency: 0,
    description_length: 0,
    duplicate_description: 0,
    duplicate_title: 0,
    external_links: 0,
    h1_count: 0,
    h2_count: 0,
    h3_count: 0,
    have_flash: 0,
    have_frame: 0,
    have_lorem_ipsum: 0,
    have_page_duplicates: 0,
    images: 0,
    images_invalid_alt: 0,
    images_invalid_title: 0,
    internal_links: 0,
    last_modified: 0,
    links_broken: 0,
    meta_noindex: 0,
    number_of_redirects: 0,
    page_size: 0,
    redirect_url: 0,
    referrer_pages: 0,
    rel_canonical: 0,
    seo_friendly_url: 0,
    status_code: 0,
    title: 0,
    title_consistency: 0,
    title_length: 0,
    url: 0,
    url_characters_check: 0,
    url_length: 0,
    url_length_ok: 0,
    word_count: 0
  },
  auditCompare: null,
  loading: false,
  domains: []
}

const websiteAuditReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomains.type:
      return {
        ...state,
        loading: true,
        domains: initialState.domains
      }
    case actions.loadDomainsSuccess.type:
      return {
        ...state,
        loading: false,
        domains: payload.domains
      }
    case actions.sortDomainsAuditReport.type: {
      
      return {
        ...state,
        domains: [...getSorted(payload.value, payload.order, state.domains)] || state.domains
      }
    }

    case actions.restartAudit.type: {
      const {domainId} = payload
      return {
        ...state,
        domains: state.domains.map(domain => {
          if(domain.id !== domainId) return domain

          return {
            ...domain,
            attributes: {
              ...domain.attributes,
              status: 'in_queue'
            }
          }
        })
      }
    }
    case actions.getAuditReport.type:
      return {
        ...state,
        loading: true
      }

    case actions.getCompareAuditReport.type:
      return {
        ...state,
        auditCompare: null,
        loading: true
      }

    case actions.getAllAuditReports.type:
      return {
        ...state,
        loading: true
      }

    case actions.getAuditReportSuccess.type:
      return {
        ...state,
        audit: {
          [payload.domainId]: payload.data
        },
        loading: false
      }

    case actions.getCompareAuditReportSuccess.type:
      return {
        ...state,
        auditCompare: payload.data,
        loading: false
      }

    case actions.getAllAuditReportsSuccess.type:
      return {
        ...state,
        audits: payload.data.audits,
        fixesList: payload.data.fixesList,
        loading: false
      }

    case actions.getAuditCrawlDataSuccess.type:
      return {
        ...state,
        auditCrawlData: payload.data.map(item => {
          return {
            id: item.id,
            attributes: {
              ...item.attributes.page
            }
          }
        }),
        auditCrawlDataIssues: {
          ...processAuditIssues(payload.data, initialState.auditCrawlDataIssues)
        },
        loading: false
      }

    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default websiteAuditReducer
